import LoginForm from '@/features/auth/components/loginform';
import { LoginLayout } from '@/routes/trainee/login-layout';

// Admin magic-link login. Ports app/[brand]/login/admin/page.tsx, wrapping the
// login form in the shared two-column login shell.
export function AdminLogin() {
  return (
    <LoginLayout>
      <LoginForm />
    </LoginLayout>
  );
}
